module.exports = __webpack_public_path__ + "static/media/brad-parry.18a57b22.png";